(function () {
  'use strict';

  var CLE_ERR = 'lys_err';        // tampon local, survit au rechargement dans le même onglet
  var MAX = 6;                    // on garde les 6 premières : au-delà c'est du bruit répétitif

  /* ── tampon local, indépendant de tout réseau ─────────────────────────── */
  function tampon() {
    try { return JSON.parse(sessionStorage.getItem(CLE_ERR) || '[]'); } catch (e) { return []; }
  }
  function noter(msg, src) {
    try {
      msg = String(msg || '').slice(0, 110);
      if (!msg) return;
      var t = tampon();
      // pas de doublon : une même erreur en boucle ne doit pas saturer le tampon
      for (var i = 0; i < t.length; i++) if (t[i].m === msg) { t[i].n++; sessionStorage.setItem(CLE_ERR, JSON.stringify(t)); return; }
      if (t.length >= MAX) return;
      t.push({ m: msg, s: String(src || '').slice(0, 60), n: 1, p: location.pathname.slice(0, 60) });
      sessionStorage.setItem(CLE_ERR, JSON.stringify(t));
    } catch (e) { /* silencieux : ce fichier EST le rapporteur, l\'appeler ici bouclerait */ }
  }

  function ga(name, params) {
    try { if (window.gtag) window.gtag('event', name, Object.assign({ event_category: 'lys_perf' }, params || {})); } catch (e) { /* silencieux : ce fichier EST le rapporteur, l\'appeler ici bouclerait */ }
  }

  /* ── point d'entrée COURT pour les blocs catch du thème ───────────────── */
  window.LE = function (e, ou) {
    try {
      var m = (e && (e.message || e.reason || e.name)) || String(e || '');
      noter(m, ou || 'catch');
      ga('js_catch', { msg: String(m).slice(0, 110), src: String(ou || 'catch').slice(0, 60) });
    } catch (x) { /* silencieux : ce fichier EST le rapporteur, l\'appeler ici bouclerait */ }
  };
  window.LYS_ERR = function () {
    try {
      var t = tampon();
      if (!t.length) return null;
      return t.map(function (x) { return x.m + (x.n > 1 ? ' ×' + x.n : '') + (x.s ? ' @' + x.s : ''); }).join(' | ').slice(0, 240);
    } catch (e) { return null; }
  };

  try {
    var HB = 'lys_hb', LAST = 'lys_hb_page';
    if (sessionStorage.getItem(HB) === 'live') {
      var ou = (sessionStorage.getItem(LAST) || '').slice(0, 80);
      ga('suspected_crash', { crashed_on: ou });
      noter('suspected_crash', ou);
    }
    sessionStorage.setItem(HB, 'live');
    sessionStorage.setItem(LAST, location.pathname);

    function clean() { try { sessionStorage.setItem(HB, 'clean'); } catch (e) { /* silencieux : ce fichier EST le rapporteur, l\'appeler ici bouclerait */ } }
    window.addEventListener('pagehide', clean);
    window.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') clean(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { try { sessionStorage.setItem(HB, 'live'); } catch (e) { /* silencieux : ce fichier EST le rapporteur, l\'appeler ici bouclerait */ } } });

    window.addEventListener('error', function (e) {
      var m = ((e && e.message) || '').slice(0, 120), s = ((e && e.filename) || '').slice(0, 80);
      /* ⛔ 09/08 — SANS LA LIGNE, UNE ERREUR INLINE EST INTROUVABLE.
         Constat : sur 14 jours, la seule erreur identifiée est « TypeError: Attempted to assign to
         readonly property. » (51×) — message PROPRE À SAFARI, donc irreproductible sous Chrome.
         Et `e.filename` valait l'URL de la PAGE, jamais un .js : l'erreur vient donc d'un script
         INLINE du thème, que `src` ne pouvait pas désigner. lineno/colno pointent la ligne exacte
         du HTML rendu — c'est le seul chaînon qui manquait pour la corriger. */
      var pos = (e && e.lineno) ? (e.lineno + ':' + (e.colno || 0)) : '';
      ga('js_error', { msg: m, src: s, pos: pos });
      noter(m + (pos ? ' @L' + pos : ''), s);
    }, true);
    window.addEventListener('unhandledrejection', function (e) {
      var m = String((e && e.reason) || '').slice(0, 120);
      ga('js_reject', { msg: m });
      noter(m, 'promesse');
    });

    /* Diag au chargement : appareil, <video> présentes, <video> réellement chargées.
       video_active doit rester bas sur mobile (idéalement ~1 = héros). Mesure en idle : sinon
       matchMedia/innerWidth forcent un reflow pendant le chargement (perf 24/07). */
    window.addEventListener('DOMContentLoaded', function () {
      var run = function () {
        try {
          var touch = (window.matchMedia && matchMedia('(hover: none) and (pointer: coarse)').matches) || ('ontouchstart' in window);
          var vids = document.querySelectorAll('video');
          var active = 0;
          Array.prototype.forEach.call(vids, function (v) { if (v.currentSrc || v.getAttribute('src')) active++; });
          ga('lys_diag', { is_mobile: touch ? 1 : 0, video_count: vids.length, video_active: active, vp_w: window.innerWidth || 0 });
        } catch (e) { window.LE && window.LE(e, 'diag'); }
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 6000 });
      else setTimeout(run, 2500);
    });
  } catch (e) { /* silencieux : ce fichier EST le rapporteur, l\'appeler ici bouclerait */ }
})();
